export default __webpack_public_path__ + "static/media/send.8c330a13.svg";